module.exports = __webpack_public_path__ + "img/sewage-pipe.a01a610f.png";